<script>
    import { onMount } from "svelte";
    import {
        getAmountInCurrency,
        getAmountInShort,
        getNumberWithComma,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";
    import { user } from "../../../stores";

    export let totals = {};
    export let isListView = true;
    export let accountId;

    let data = [];
    let itemsDetails = [
        {
            propName: "accounts",
            icon: "fa fa-user-doctor",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            colSpan: $user.role == 2 ? 3 : 2,
            colOrder: 1,
            onClick: () => {
                $user.role > 2 && goToURL(`/Account`);
            },
        },
        {
            propName: "patients",
            icon: "fa fa-user-injured",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            colSpan: $user.role == 2 ? 3 : 2,
            colOrder: 1,
            onClick: () => {
                goToURL(`/Patient/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "encounters",
            icon: "fa fa-hand-holding-medical",
            displayName: "Total Encounters",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            colSpan: $user.role == 2 ? 3 : 2,
            colOrder: 2,
            onClick: () => {
                goToURL(`/PatientEncounter/page=0&size=25&status=0${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            // two closedEncounters, this one hide if user is NOT doctor
            propName: "closedEncounters",
            icon: "fa fa-hand-holding-medical",
            displayName: "Closed Encounters",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            isHidden: $user.role == 100 || $user.role == 80,
            colSpan: 3,
            colOrder: 2,
            onClick: () => {
                goToURL(
                    `/PatientEncounter/page=0&size=25&status=0&billingStatus=5${accountId ? `&doctorId=${accountId}` : ""}`,
                );
            },
        },
        {
            propName: "quotes",
            icon: "fa-solid fa-person-circle-question",
            displayName: "Fee Estimates",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            colSpan: 2,
            colOrder: 1,
            isHidden: $user.role != 100 && $user.role != 80,
            onClick: () => {
                goToURL(`/PatientQuote/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "estimates",
            icon: "fa fa-file-invoice",
            displayName: "Quotes",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            colSpan: $user.role == 2 ? 3 : 2,
            colOrder: 1,
            onClick: () => {
                goToURL(`/Estimates/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "invoices",
            icon: "fa fa-file-invoice-dollar",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            colSpan: $user.role == 2 ? 3 : 2,
            colOrder: 1,
            onClick: () => {
                goToURL(`/Invoices/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            // two closedEncounters, this one hide if user IS doctor
            propName: "closedEncounters",
            icon: "fa fa-hand-holding-medical",
            displayName: "Closed Encounters",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            isHidden: $user.role == 2,
            colSpan: 3,
            onClick: () => {
                goToURL(
                    `/PatientEncounter/page=0&size=25&status=0&billingStatus=5${accountId ? `&doctorId=${accountId}` : ""}`,
                );
            },
        },
        {
            propName: "amountRequested",
            icon: "fa-solid fa-file-circle-exclamation",
            displayName: "Amount Requested",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getAmountInCurrency(value)}`;

                return `${getAmountInShort(value)} / ${getAmountInShort(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 100 && $user.role != 80,
            colSpan: 3,
            colOrder: 2,
            onClick: () => {
                goToURL(`/Receipts/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "totalCollected",
            icon: "fa-solid fa-file-circle-check",
            displayName: "Total collected",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getAmountInCurrency(value)}`;

                return `${getAmountInShort(value)} / ${getAmountInShort(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 100 && $user.role != 80,
            colSpan: 3,
            colOrder: 2,
            onClick: () => {
                goToURL(`/Receipts/page=0&size=25&paymentStatus=1${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "totalsCollected",
            icon: "fa fa-receipt",
            displayName: "Total collected",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getAmountInCurrency(value)}`;

                return `${getAmountInShort(value)} / ${getAmountInShort(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 2,
            colSpan: 3,
            onClick: () => {
                goToURL(`/Receipts/page=0&size=25&paymentStatus=1`);
            },
        },
        {
            propName: "payments",
            icon: "fa fa-receipt",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 2,
            colSpan: 3,
            onClick: () => {
                goToURL(`/Receipts/page=0&size=25&paymentStatus=1`);
            },
        },
        {
            propName: "totalRefunded",
            icon: "fa-solid fa-reply-all",
            displayName: "Total Refunded",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getAmountInCurrency(value)}`;

                return `${getAmountInShort(value)} / ${getAmountInShort(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 100 && $user.role != 80,
            colSpan: 3,
            colOrder: 3,
            onClick: () => {
                goToURL(`/Receipts/page=0&size=25&paymentStatus=5${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "totalOverpaid",
            icon: "fa-solid fa-scale-unbalanced-flip",
            displayName: "Total Overpaid",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getAmountInCurrency(value)}`;

                return `${getAmountInShort(value)} / ${getAmountInShort(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 100 && $user.role != 80,
            colSpan: 2,
            colOrder: 3,
            onClick: () => {
                goToURL(`/Overpaid/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "totalUnderpaid",
            icon: "fa-solid fa-scale-unbalanced",
            displayName: "Total Underpaid",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getAmountInCurrency(value)}`;

                return `${getAmountInShort(value)} / ${getAmountInShort(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 100 && $user.role != 80,
            colSpan: 2,
            colOrder: 3,
            onClick: () => {
                goToURL(`/Underpaid/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}`);
            },
        },
        {
            propName: "badDebtors",
            icon: "fa-solid fa-user-secret", 
            displayName: "Bad Debtors",
            valueFormatter: (value, totalValue) => {
                if (!totalValue) return `${getNumberWithComma(value)}`;

                return `${getNumberWithComma(value)} / ${getNumberWithComma(
                    totalValue,
                )}`;
            },
            isHidden: $user.role != 100 && $user.role != 80,
            colSpan: 2,
            colOrder: 3,
            onClick: () => {
                goToURL(`/Patient/page=0&size=25${accountId ? `&doctorId=${accountId}` : ""}&badDebtor=1`);
            },
        },
    ];

    onMount(() => {
        if (totals) {
            itemsDetails.map((item) => {
                const {
                    isHidden,
                    propName,
                    icon,
                    colSpan,
                    colOrder,
                    onClick,
                    displayName: itemDisplayName,
                    valueFormatter,
                } = item;

                const displayName = itemDisplayName
                    ? itemDisplayName
                    : propName;

                const totalValue = totals[`${propName}Total`];

                const formattedValue = valueFormatter
                    ? valueFormatter(totals[propName], totalValue)
                    : totals[propName];

                data.push({
                    isHidden,
                    name: displayName,
                    value: formattedValue,
                    icon,
                    colSpan: colSpan ?? 3,
                    colOrder,
                    onClick,
                });
            });

            data = [...data];
        }
    });
</script>

<div class="flex-1 flex flex-col p-6">
    {#if data.length == 0}
        <div class="flex-1 items-center text-center">Nothing to display</div>
    {:else if !isListView}
        <div class="grid grid-cols-6 gap-4">
            {#each data.filter((d) => !d.isHidden) as item, i}
                <div
                    on:click={() => item.onClick()}
                    class={`hover:bg-blue-100 hover:cursor-pointer capitalize border rounded p-4 col-span-${item.colSpan} flex flex-row justify-between`}
                >
                    <div class="flex flex-row justify-start items-center">
                        <i
                            class={`${item.icon} text-[#6F726C] mr-2 w-12`}
                            style="font-size:24px"
                        />
                        <span class="capitalize">{item.name}</span>
                    </div>
                    <div class="text-end">
                        {item.value}
                    </div>
                </div>
            {/each}
        </div>
    {:else}
        <div class="flex flex-col flex-1 w-full overflow-x-auto lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                {#each data.filter((d) => d.colOrder == 1) as item}
                    <div
                        class="flex flex-1 items-center justify-between border-b cursor-pointer hover:font-bold"
                        on:click|preventDefault={() => item.onClick()}
                    >
                        <div class="flex justify-start items-center">
                            <i
                                class={`${item.icon} text-[#6F726C] w-8`}
                                style="font-size:18px"
                            />
                            <span class="capitalize">{item.name}</span>
                        </div>
                        <span class="text-end">{item.value}</span>
                    </div>
                {/each}
            </div>

            <div class="divider lg:divider-horizontal" />

            <div class="flex flex-col flex-1 gap-y-4 h-full">
                {#each data.filter((d) => d.colOrder == 2) as item}
                    <div
                        class="flex flex-1 items-center justify-between border-b cursor-pointer hover:font-bold"
                        on:click|preventDefault={() => item.onClick()}
                    >
                        <div class="flex justify-start items-center">
                            <i
                                class={`${item.icon} text-[#6F726C] w-8`}
                                style="font-size:18px"
                            />
                            <span class="capitalize">{item.name}</span>
                        </div>
                        <span class="text-end">{item.value}</span>
                    </div>
                {/each}
            </div>

            <div class="divider lg:divider-horizontal" />

            <div class="flex flex-col flex-1 gap-y-4 h-full">
                {#each data.filter((d) => d.colOrder == 3) as item}
                    <div
                        class="flex flex-1 items-center justify-between border-b cursor-pointer hover:font-bold"
                        on:click|preventDefault={() => item.onClick()}
                    >
                        <div class="flex justify-start items-center">
                            <i
                                class={`${item.icon} text-[#6F726C] w-8`}
                                style="font-size:18px"
                            />
                            <span class="capitalize">{item.name}</span>
                        </div>
                        <span class="text-end">{item.value}</span>
                    </div>
                {/each}
            </div>
        </div>
    {/if}
</div>

<style>
    .item-dot {
        background-color: hsl(var(--s) / var(--tw-bg-opacity));
    }
</style>
